import { CurrencyCodeType, PaymentRailType } from '@/types/currency';

export interface CreateRecipientRequest {
  readonly beneficiaryId: string;
  readonly individualName?: string;
  readonly businessName?: string;
  readonly currency: CurrencyCodeType;
  readonly type: PaymentRailType;
  readonly contactId?: string | null;
  readonly belongsToBeneficiary?: boolean;
  readonly nickname?: string | null;
  readonly countryOfIncorporation?: string;
  readonly details: Record<string, unknown>;
}

export enum CryptoRecipientStatus {
  PENDING_REVIEW = 'PENDING_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export interface RecipientResponse {
  readonly id: string;
  readonly beneficiaryId?: string;
  readonly individualName?: string;
  readonly businessName?: string;
  readonly currency: CurrencyCodeType;
  readonly type: PaymentRailType;
  readonly internalTransfer: boolean;
  readonly countryOfIncorporation?: string;
  readonly nickname?: string | null;
  readonly contactId?: string | null;
  readonly belongsToBeneficiary: boolean;
  readonly details: Record<string, unknown>;
  readonly cryptoStatus?: CryptoRecipientStatus | null;
}

export interface UpdateRecipientNicknameRequest {
  readonly nickname: string | null;
}

export interface VaspResponse {
  readonly id: string;
  readonly name: string;
}

export const isRecipientResponse = (value: unknown): value is RecipientResponse => {
  return (
    value !== null &&
    typeof value === 'object' &&
    'id' in value &&
    'type' in value &&
    'details' in value
  );
};

export const isRecipientResponseOrNull = (value: unknown): value is RecipientResponse | null => {
  return value === null || isRecipientResponse(value);
};

export const isArrayOfRecipientResponse = (
  value: unknown,
): value is readonly RecipientResponse[] => {
  return Array.isArray(value) && value.every(isRecipientResponse);
};
